import { render, staticRenderFns } from "./WatchTvUserData.vue?vue&type=template&id=a5746ee0&scoped=true&"
import script from "./WatchTvUserData.vue?vue&type=script&lang=js&"
export * from "./WatchTvUserData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5746ee0",
  null
  
)

export default component.exports